import React, { useContext, useEffect, useState } from "react";
import UserPostsFun from "./UserPostsFun";

import axios from "axios";
import { AuthContext } from "../../../../context/App-Context";

const UserProfilePostsContainer = () => {
  const auth = useContext(AuthContext);

  const [data, setData] = useState(null);

  useEffect(() => {
    const fetchData = async () => {
      // console.log("starting");
      // console.log(
      //   "user logged in verification , userProfileposts Container vvv"
      // );
      // console.log(auth);
      // console.log(auth.loginVar);
      // console.log(auth.loginVar.tokenLoginData);
      try {
        //setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/zeusapolis/func-rts-upst/getusertemplegridposts/${auth.loginVar}`
        ); // Example API endpoint
        // console.log(response.data.data[0]);
        // console.log(response.data.data[0].username);
        setData(response.data.data.functionGo);
        // console.log(response.data.data);
        // console.log(response.data.data.templeGrid_PhotoVault);
      } catch (err) {
        // setError(err.message);
      } finally {
        // setLoading(false);
      }
    };
    fetchData();
    //console.log(auth.loginVar);
  }, [auth.loginVar]);

  return (
    <div>
      {data && <UserPostsFun postFunction={data} />}

      <div>{!data && <div>no posts yet</div>}</div>
    </div>
  );
};

export default UserProfilePostsContainer;
